import React, { useEffect } from 'react';
import {
    Box,
    CircularProgress,
    Divider,
    Stack,
    Button,
    // ListItem,
    Card,
    CardContent,
    TextField,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import { useState, Downgraded } from '@hookstate/core';
import RouteConstants from '../../constants/routeConstants';
import { useEventState, updateModuleState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import {
    NO_ACCESS_PERMISSION,
    VIEW_PERMISSION,
    FULL_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
// import AppBarHeader from '../../sharedcomponents/appbarHeader/appbarHeader';
import Title from '../../sharedcomponents/title/title';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
// import AppConstants from '../../constants/appConstants';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { useHistory, useParams, generatePath } from 'react-router-dom';
import OutfitOptionType from './outfitOptionType';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { useAgentState } from '../../hookState/AgentState';
import { isEmpty } from 'lodash-es';
import AppConstants from '../../constants/appConstants';

const theme = createTheme();

const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    inputBox: {
        width: '250px',
        flexBasis: '250px',
        flexGrow: 1,
        marginBottom: '16px',
        marginRight: '16px',
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
    },
    spacerCheck: {
        width: '250px',
        flexBasis: '250px',
        flexGrow: 1,
        marginBottom: '16px',
        marginRight: '16px',
    },
    inputIcon: {
        justifyContent: 'center',
        alignItems: 'center',
        margin: 3,
        height: 25,
        width: 25,
    },
    rowContent: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
        width: '100%',
        marginTop: '16px',
    },
    textContent: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            padding: 0,
        },
    },
});

// const outfitTypeObj = {
//     'Game Jersey': 'gameJersey',
//     'Game Short': 'gameShort',
//     'Warm-up Shirt': 'warmupShirt',
//     'Compression Tank': 'compressionTank',
//     'Compression Short': 'compressionShort',
//     'Compression Full Tight': 'compressionFullTight',
//     'Short Sleeve Polo': 'shortSleevePolo',
//     "Men's 1/4 Zip": 'mensZip',
//     'Short Sleeve T-Shirt': 'shortSleeveTShirt',
//     'Long Sleeve T-Shirt': 'longSleeveTShirt',
//     'Fleece Sweatshirt': 'fleeceSweatShirt',
//     'Fleece Sweatpants': 'fleeceSweatPants',
//     'Training Short': 'trainingShort',
// };

const CreateOutfit = (props) => {
    const history = useHistory();
    let params = useParams();
    const classes = useStyles();
    const loading = useState(false);
    const agentState = useAgentState();
    // const agentInfo = Helper.getStorage('agentInfo');
    const [asAdmin, setAsAdmin] = React.useState(false);
    const state = useState(null);
    const [modPermission, setModPermission] = React.useState(null);
    const [isDisable, setIsDisable] = React.useState(false);
    const eventState = useEventState();
    const createdByUserInfo = Helper.getStorage('userInfo');
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [userOutfitID, setUserOutfitID] = React.useState(0);
    const [participantList, setParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);
    // const moduleIndex = useState(-1);
    // const [outfitInfo, setOutfitInfo] = React.useState([]);
    const [outfitOptions, setOutfitOptions] = React.useState(null);
    const [outfitFieldOptions, setOutfitFieldOptions] = React.useState(null);
    const [checkEditPermission, setCheckEditPermission] = React.useState(false);
    const [addedFor, setAddedFor] = React.useState(0);
    const [jerseyName, setJerseyName] = React.useState('');    
    const [moduleInfo, setModuleInfo] = React.useState(null);
    // const userEvents = Helper.getStorage('UserEvents');
    const eventInfo1 = Helper.getStorage('eventInfo');
    const prevOutfitState = useState(null);
    const [outfitTypeObj, setOutfitTypeObj] = React.useState(null);
    const [outfitInfoObj, setOutfitInfoObj] = React.useState(null);

    let eventRole = '';
    if (!isEmpty(eventInfo1)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo1.eventID
                )?.eventRole
                : '';
    }
    // const getOutfitType =() =>{
    //     ApiHelper.get(APIURLConstants.GET_OUTFIT_TYPES).then(
    //         async (res) => {
    //             let typesData = {};
    //             let data = res.data; 
    //             data.map((outfit) => { 
    //                     const outfitName = outfit.outfitName;
    //                     let outfitDetails = outfit.outfitDetail;
    //                     typesData[outfitDetails] = outfitName;

    //             })
    //             setOutfitTypeObj(typesData)
    //             console.log("res", res,typesData);

    //         });
    // }
    function sortByTypeSortOrder(arr) {
        arr.sort((a, b) => {
          if (a.typeSortOrder < b.typeSortOrder) {
            return -1; 
          }
          if (a.typeSortOrder > b.typeSortOrder) {
            return 1;
          }
          return 0;
        });
        return arr;
      }
    const getOutfitOptions = (eventID) => {
        loading.set(true);
        let typesData = {};
        ApiHelper.get(APIURLConstants.GET_OUTFIT_TYPES(eventID)).then(
            async (res) => {
                loading.set(false)
                let data = res.data;
                data.map((outfit) => {
                    const outfitName = outfit.outfitName;
                    let outfitDetails = outfit.outfitDetail;
                    typesData[outfitDetails] = outfitName;

                })
                setOutfitTypeObj(typesData)
                // console.log("res", res,typesData);

                if (data.length > 0) {
                    ApiHelper.get(APIURLConstants.GET_OUTFIT_OPTIONS(eventID)).then(
                        async (res) => {
                            const data = res.data;
                            // console.log("data",data);
                            setOutfitOptions(data);
                            let outfitOptionObj = {};
                            let newOutfitFieldOptions = [];
                            data.map((outfit) => {
                                outfitOptionObj[outfit.outfitName] = '';
                                newOutfitFieldOptions.push({
                                    OutfitTypeID: outfit.outfitTypeID,
                                    OutfitName: outfit.outfitName,
                                    OutfitType: outfit.outfitDetail,
                                    typeSortOrder:outfit.typeSortOrder,
                                    Values: outfit.values,
                                });
                            });
                            setOutfitFieldOptions(sortByTypeSortOrder(newOutfitFieldOptions));

                            if (params.userOutfitID) {
                                if (history.location.state.outfitState) {
                                    const data = history.location.state.outfitState;
                                    if (data.userID) {
                                        setJerseyName(data.jerseyName)
                                        const index =
                                            history.location.state.participantList.findIndex(
                                                (user) => user.userID == data.userID
                                            );
                                        if (index > -1) {
                                            setParticipant(
                                                history.location.state.participantList[
                                                index
                                                ]
                                            );
                                        }
                                        setAddedFor(data.userID);
                                    }
                                    let editOutfitState = JSON.parse(data.outfitInfo);

                                    setUserOutfitID(Number(params.userOutfitID));

                                    let newState = { ...state.get() };
                                    if (Object.keys(typesData).length !== 0) {
                                        // console.log("editOutfitState",editOutfitState, outfitTypeObj,typesData);
                                        editOutfitState.map((row) => {
                                            newState[typesData[row.OutfitType]] = row.Value;
                                        });
                                        state.set(newState);
                                    }
                                }
                            } else {
                                // console.log("into else",outfitOptionObj,newOutfitFieldOptions);
                                state.set(outfitOptionObj);
                            }

                            if (
                                !(
                                    Helper.isAdminUser(userInfo) ||
                                    (userInfo.roles && Helper.isEventAdmin(userInfo))
                                )
                            ) {
                                await getUserOutfitOption();
                            }

                            loading.set(false);
                        }
                    );
                }
            });

    };

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            if (
                eventState.eventDetail.moduleDetails.get() &&
                moduleInfo == null
            ) {
                const index = eventState.eventDetail.moduleDetails
                    .get()
                    .findIndex((element) => {
                        if (element.moduleName === 'Outfit') {
                            return true;
                        }
                    });
                if (index >= 0) {
                    const info = eventState.eventDetail.moduleDetails
                        .attach(Downgraded)
                        .get();
                        if(!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo))){
                            setModuleInfo(info[index].details);
                        }
                    
                }
            }

            if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo))) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'OUTFIT')
                    );
                }
            } else if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
                if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
                    setAsAdmin(true);
                } else {
                    setAsAdmin(true);
                }
            }
        }
    }, [eventState]);

    useEffect(() => {
        const asyncFn = async () => {
            if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
                if (
                    history.location &&
                    typeof history.location.state !== 'undefined'
                ) {
                    // const gEventInfo = Helper.getStorage('eventInfo');
                    // console.log(history.location.state)
                    // setParticipantList(history.location.state.participantList); 
                    // await getOutfitOptions(gEventInfo.eventID);    

                }
                const gEventInfo = Helper.getStorage('eventInfo');
                eventInfo.set(gEventInfo);
                setParticipantList(history.location &&
                    typeof history.location.state !== 'undefined' ? history.location.state.participantList : null);
                // if (eventInfo.get() != null) {
                // setTimeout(() => {
                // await getOutfitType();
                await getOutfitOptions(gEventInfo.eventID);
                // },4000);
                if (modPermission == FULL_PERMISSION) {
                    setCheckEditPermission(true);
                } else if (modPermission == VIEW_PERMISSION) {
                    setCheckEditPermission(false);
                } else {
                    setCheckEditPermission(false);
                }
            }
        }
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            asyncFn();
        }
    }, [modPermission]);

    const getUserOutfitOption = async () => {
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        let typesData = {};
        await ApiHelper.get(APIURLConstants.GET_OUTFIT_TYPES(eventInfo.get().eventID)).then(
            res => {
                loading.set(false)
                let data = res.data;
                data.map((outfit) => {
                    const outfitName = outfit.outfitName;
                    let outfitDetails = outfit.outfitDetail;
                    typesData[outfitDetails] = outfitName;

                })
                setOutfitTypeObj(typesData)
                // console.log("res", res,typesData);

            });
        await ApiHelper.get(
            APIURLConstants.GET_USER_OUTFIT_INFO(
                eventInfo.get().eventID,
                agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID
            )
        )
            .then((res) => {
                if (res.data) {
                    const data = res.data;
                    setOutfitInfoObj(data)
                    setJerseyName(data.jerseyName)
                    let editOutfitState = JSON.parse(data.outfitInfo);

                    setUserOutfitID(data.userOutfitID);
                    let newState = { ...state.get() };
                    // let keys = Object.keys(newState);
                    // keys.map((key) => {
                    //     newState[key] = '';
                    // });
                    editOutfitState.map((row) => {
                        newState[typesData[row.OutfitType]] = row.Value;
                    });
                    // eslint-disable-next-line no-debugger
                    // debugger
                    // console.log(newState);
                    prevOutfitState.set(editOutfitState)
                    state.set(newState);
                }
            })
            .catch((err) => {
                //... Check if user's session has expired
                if (err.response && err.response.status === 401) {
                    console.log(err);
                }
            });
    };

    const handleBtnCancel = () => {
        props.history.goBack();
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        let outfitInfo = [];
        if(jerseyName.trim() == ''){
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: "Please Enter Jersey Name",
            });
            return false
        }else{
            outfitOptions.map((outfit) => {
                let obj = {
                    OutfitTypeID: outfit.outfitTypeID,
                    OutfitType: outfit.outfitDetail,
                    Value: state.nested(outfit.outfitName).get()
                };
                outfitInfo.push(obj);
            });
    
            const payLoad = {
                userOutfitID: userOutfitID,
                userID: participant
                    ? participant.userID
                    : agentState.visible.value
                        ? agentState.user.get() && agentState.user.get().userID
                        : addedFor
                            ? addedFor
                            : userInfo.userID,
                eventID: eventInfo.get().eventID,
                createdBy: createdByUserInfo.userID,                 
                jerseyName:jerseyName,
                outfitInfo: outfitInfo,
            };
    
            setIsDisable(true);
            ApiHelper.post(APIURLConstants.POST_OUTFIT, payLoad)
                .then(async (res) => {
                    if (res.data == true) {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message:
                                userOutfitID == 0
                                    ? 'Outfit information added successfully'
                                    : 'Outfit information updated successfully',
                        });
                        setDisableBtn(true)
                        await updateModuleState();
                        setIsDisable(false);
                        setTimeout(() => {
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles && Helper.isEventAdmin(userInfo))
                            ) {
                                // resetState();
                                props.history.push(
                                    generatePath(RouteConstants.EVENT_OUTFIT, {
                                        eventID: eventInfo.get().eventID,
                                    })
                                );
                            } else {
                                props.history.push(generatePath(RouteConstants.EVENT_DETAIL, {
                                    eventID: eventInfo.get().eventID,
                                }))
                                getUserOutfitOption();
                            }
                        }, 1000);
    
                    }
                })
                .catch((error) => {
                    console.log(error)
                    let message = '';
                    setIsDisable(false);
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding outfit information';
                    }
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                });
        }
        
    };

    const setOutfitValue = (value, outfit) => {
        state[outfit].set(value);
        if (userOutfitID > 0) {
            handleDisableBtn();
        }
    };
    const handleDisableBtn = () => {
// console.log("history.location.state",history.location.state);
        if (history.location.state != undefined) {
            let currentData = state.attach(Downgraded).get();

            let editOutfitState = JSON.parse( history.location.state.outfitState != undefined ? history.location.state.outfitState?.outfitInfo : outfitInfoObj.outfitInfo );
            let prevData = { ...state.get() };
            let keys = Object.keys(prevData);
            keys.map((key) => {
                prevData[key] = null;
            });
            editOutfitState.map((row) => {
                prevData[outfitTypeObj[row.OutfitType]] = row.Value;
            });
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        } else {
            let currentData = state.attach(Downgraded).get();

            let editOutfitState = prevOutfitState.attach(Downgraded).get();
            // console.log("editOutfitState",editOutfitState);
            let prevData = { ...state.get() };
            let keys = Object.keys(prevData);
            keys.map((key) => {
                prevData[key] = null;
            });
            editOutfitState.map((row) => {
                prevData[outfitTypeObj[row.OutfitType]] = row.Value;
            });
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }
    }
    const onJerseyNameChange = (name) => {
        setDisableBtn(false)
        setJerseyName(name)
    }
    console.log("outfitFieldOptions",outfitFieldOptions);
    
    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Box
                    className="contentBox"
                    style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                    <Box
                        sx={{
                            width: '100%',
                            backgroundColor: '#fff',
                            '& .MuiFormControl-root': { width: '100%' },
                        }}>
                        <Box component="form" onSubmit={handleSubmit}>
                            <Box>
                                {/* <AppBarHeader title={params.userOutfitID ? 'Edit Outfit Form' : 'Create Outfit Form'} /> */}
                                <Title title={Helper.getModuleName(eventInfo.get() ? eventInfo.moduleDetails.get() : [],
                                    AppConstants.EVENT_MODULES.OUTFIT)} />
                            </Box>
                            {moduleInfo ? (
                                <DetailsComponent data={moduleInfo} />
                            ) : null}
                            {participantList && (
                                <Box
                                    sx={{
                                        width: ' 30%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.3,
                                        justifyContent: 'center',
                                        mx: 'auto',

                                        // '& .MuiFormControl-root': { width: '100%' },
                                    }}>
                                    <ParticipantAutoList
                                        disableParticipant={
                                            params.userOutfitID ? true : false
                                        }
                                        participant={participant}
                                        setParticipant={setParticipant}
                                        participantList={participantList}
                                        modPermission={modPermission}
                                    />
                                </Box>
                            )}
                            <Box sx={{ width: '90%', mt: 1, display:'flex', alignItems:'center' }}>
                                <Typography sx={{width:'100%', fontWeight:'bold'}} variant='span'>Last Name on Jersey (please include any suffixes or accent marks)
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Jersey Name*"
                                    id="outlined-basic"
                                    variant="outlined"                                    
                                    onChange={(event) => {
                                        onJerseyNameChange(event.target.value)
                                    }} 
                                    value={jerseyName}
                                />
                            </Box>
                            <Box className={classes.rowContent}>
                                {outfitFieldOptions &&
                                    outfitFieldOptions.length > 0 ? (
                                    outfitFieldOptions.map(
                                        (outfitField, index) => (
                                            <OutfitOptionType
                                                key={`outfieldType_${index}`}
                                                data={outfitField}
                                                editPermission={
                                                    checkEditPermission
                                                }
                                                value={Object.keys(state).length !== 0 ? state[
                                                    outfitField.OutfitName
                                                ].get() : null}
                                                classes={classes}
                                                setOutfitValue={setOutfitValue}
                                            />
                                        )
                                    )
                                ) : outfitFieldOptions ? (
                                    <Card
                                        classes={{ root: classes.paperContent }}
                                        sx={{ width: '100%' }}>
                                        <CardContent
                                            sx={{ p: 2 }}
                                            className={classes.cardContent}>
                                            <Box
                                                className={classes.textContent}>
                                                Please contact LetsGO admin for
                                                adding event outfit options
                                            </Box>
                                        </CardContent>
                                    </Card>
                                ) : null}
                                {outfitFieldOptions &&
                                    outfitFieldOptions.length > 0 &&
                                    [1, 2, 3, 4].map((item) => {
                                        return (
                                            <Box
                                                key={`outfitInfoSpacer_${item}`}
                                                className={
                                                    classes.spacerCheck
                                                }></Box>
                                        );
                                    })}
                            </Box>
                            {outfitFieldOptions &&
                                outfitFieldOptions.length > 0 ? (
                                <Divider component="div" />
                            ) : null}
                            {outfitFieldOptions &&
                                outfitFieldOptions.length > 0 ? (
                                checkEditPermission ? (
                                    asAdmin ? (
                                        <ButtonContainer
                                            //handleClick={handleClick}
                                            handleCancel={handleBtnCancel}
                                            buttonText={
                                                userOutfitID > 0
                                                    ? 'Update'
                                                    : 'Submit'
                                            }
                                            disableUpdateButton={userOutfitID > 0 ? disableBtn : false}
                                            disableButton={
                                                isDisable ||
                                                    eventInfo1.readonlyOrHide ===
                                                    1
                                                    ? eventRole !==
                                                        AppConstants
                                                            .EVENT_ROLES[0]
                                                        ? userInfo.userType !==
                                                            AppConstants
                                                                .USER_TYPES[0]
                                                            ? true
                                                            : false
                                                        : false
                                                    : false
                                            }
                                        />
                                    ) : (
                                        <Stack
                                            spacing={2}
                                            direction="row-reverse"
                                            sx={{ m: 1 }}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                disabled={
                                                    isDisable ||
                                                        eventInfo1
                                                            .readonlyOrHide === 1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : userOutfitID > 0 ? disableBtn : false
                                                            : userOutfitID > 0 ? disableBtn : false
                                                        : userOutfitID > 0 ? disableBtn : false
                                                }>
                                                {userOutfitID > 0
                                                    ? 'Update'
                                                    : 'Submit'}
                                            </Button>
                                        </Stack>
                                    )
                                ) : null
                            ) : null}
                        </Box>
                        {snackBarProps.openSnack && (
                            <CustomizedSnackbars
                                {...snackBarProps}
                                onClose={() =>
                                    setSnackBarProps({
                                        ...snackBarProps,
                                        openSnack: false,
                                    })
                                }></CustomizedSnackbars>
                        )}
                    </Box>
                </Box>
            )}
        </>
    );
};
export default {
    routeProps: {
        path: [RouteConstants.CREATE_OUTFIT, RouteConstants.EDIT_OUTFIT],
        component: CreateOutfit,
    },
    name: 'CreateOutfit',
};
